import { FC } from 'react';
import { localeStore } from 'src/mobx/localesStore';

interface IProps {
  title: string;
}

const CustomerProfileEditStatisticsFieldTitle: FC<IProps> = ({ title }: IProps): JSX.Element => {
  return <p className="family-bold text-size-10 color-dark font-weight-700 text-uppercase letter-spacing-12">{localeStore.t(title)}</p>;
};

export default CustomerProfileEditStatisticsFieldTitle;
